module.exports = "../fonts/Arsenal-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Arsenal-Bold.ttf
// module id = 583
// module chunks = 0